import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import { useState, useEffect } from "react";

const TABS = [
  { to: "/emails",                 icon: "fi-rr-envelope",      label: "Email Vault",      limited: false },
  { to: "/emails-lead-magnet",     icon: "fi-rr-link",          label: "Lead Magnets",     limited: true  },
  { to: "/emails-social-template", icon: "fi-rr-layout-fluid",  label: "Templates",        limited: false },
  { to: "/emails-sale-campaign",   icon: "fi-rr-file",          label: "Sales Campaigns",  limited: true  },
  { to: "/emails-drafts",          icon: "fi-rr-edit",          label: "My Drafts",        limited: false },
];

const TARGET_DATE = new Date("2026-06-15T00:00:00");

function useCountdown() {
  const calc = () => {
    const diff = TARGET_DATE - new Date();
    if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
    return {
      d: Math.floor(diff / 86400000),
      h: Math.floor((diff % 86400000) / 3600000),
      m: Math.floor((diff % 3600000) / 60000),
      s: Math.floor((diff % 60000) / 1000),
    };
  };
  const [time, setTime] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(id);
  }, []);
  return time;
}

function CountdownBanner() {
  const { d, h, m, s } = useCountdown();
  const pad = (n) => String(n).padStart(2, "0");
  return (
    <div className="bg-secondary rounded-4 shadow-sm p-4 mb-5 d-flex align-items-center gap-3 flex-wrap mb-4">
      <i className="fi fi-rr-clock fs-4 flex-shrink-0"></i>
      <div className="flex-grow-1">
        <h5 className="mb-0">Fresh emails dropping June 15</h5>
        <p className="mb-0 small text-muted">
            We're curating a brand new collection of high-converting emails — fully refreshed and ready to help you sell.
        </p>
      </div>
      <div className="d-flex gap-2 flex-shrink-0">
        {[["Days", pad(d)], ["Hrs", pad(h)], ["Min", pad(m)], ["Sec", pad(s)]].map(([label, val]) => (
          <div key={label} className="text-center bg-white border rounded px-2 py-2" style={{ minWidth: 52 }}>
            <div className="fw-bold fs-5 lh-1">{val}</div>
            <div className="text-muted" style={{ fontSize: 11 }}>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function NavEmailMarketing() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const isLimited = user.limitedexperience == 2;

  const visibleTabs = isLimited ? TABS.filter((tab) => !tab.limited) : TABS;

  return (
    <>
      {isLimited && <CountdownBanner />}
      <ul className="nav nav-tabs justify-content-center justify-content-sm-start mb-4 border-bottom">
        {visibleTabs.map(({ to, icon, label }) => (
          <li key={to} className="nav-item">
            <Link to={to} className={`nav-link ${pathname === to ? "active" : ""}`}>
              <i className={`fi ${icon} me-2`} />
              <span className="d-none d-md-inline-block">{label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}